/* eslint-disable import/no-import-module-exports */
import { logAsyncError } from '@Utils/Decorators';
import { normalizeItems } from '@Utils';
import scrollIntoView from 'scroll-into-view';
import { getCombinedRouteParams } from '@AppRoutes/AppRoutesSelectors';
import store from '@Store';
import { updateDialog } from '@Containers/Dialogs/DialogsActions';
import { showGlobalSpinner, hideGlobalSpinner } from '@Containers/GlobalSpinner/GlobalSpinnerActions';
import { spinnerTypes } from '@Containers/GlobalSpinner/GlobalSpinnerConstants';
import { typeOfAlertIdNotFoundDialog } from './AlertsComponents/AlertIdNotFoundDialog/AlertIdNotFoundDialogConstants';
import { saveAlertsType, removeAlertActionType, setRefetchType, setMountedType } from './AlertsConstants';

import { getAllAlertsAsync, deleteAlertAsync } from './AlertsService';

import { isMounted as isMountedSelector } from './AlertsSelectors';

export function saveAlerts(alerts) {
  return {
    type: saveAlertsType,
    payload: {
      alerts,
    },
  };
}

export function fetchAlerts(force = false) {
  return logAsyncError(async (dispatch) => {
    const alerts = await getAllAlertsAsync(force);

    dispatch(saveAlerts(alerts));

    return alerts;
  });
}

export function removeAlertAction(id) {
  return {
    type: removeAlertActionType,
    payload: {
      id,
    },
  };
}

export function removeAlert(id) {
  return logAsyncError(async (dispatch) => {
    const params = {
      uuid: id,
    };

    await deleteAlertAsync(params);

    dispatch(removeAlertAction(id));
  });
}

export function setMounted(mounted) {
  return {
    type: setMountedType,
    payload: {
      mounted,
    },
  };
}

export function setRefetch(refetch) {
  return {
    type: setRefetchType,
    payload: {
      refetch,
    },
  };
}

export function resetAlerts() {
  return async (dispatch, getState) => {
    const isMounted = isMountedSelector(getState());

    if (isMounted) {
      dispatch(showGlobalSpinner(spinnerTypes.progress));
      await dispatch(fetchAlerts(true));
      dispatch(hideGlobalSpinner(spinnerTypes.progress));
    } else {
      dispatch(setRefetch(true));
    }
  };
}

export function _scrollToAlert(alertId) {
  return () => {
    const el = document.getElementById(alertId);

    // eslint-disable-next-line no-unused-expressions
    el &&
      scrollIntoView(el, {
        behavior: 'smooth',
        align: {
          top: 0,
          topOffset: 82, // header offset
        },
        time: 300,
      });
  };
}

export function processPageAlertsByAlertId(alerts) {
  const { pageAlertId } = getCombinedRouteParams(store.getState());
  const { ids } = normalizeItems(alerts);

  return (dispatch) => {
    if (!pageAlertId) {
      return;
    }

    if (ids.includes(pageAlertId)) {
      dispatch(_scrollToAlert(pageAlertId));
    } else {
      dispatch(
        updateDialog({
          id: typeOfAlertIdNotFoundDialog,
          dialogType: typeOfAlertIdNotFoundDialog,
          movable: false,
        })
      );
    }
  };
}
